import { useCallback } from 'react';

import { usePostApiParentHelperFeedbackByMessageIdMutation } from 'shared/api/gsp';

import type { Message } from 'pages/ParentHelper/types';
import type { Dispatch, SetStateAction } from 'react';
import type { PostApiParentHelperFeedbackByMessageIdArg as FeedbackType } from 'shared/api/gsp';

export const useSendFeedback = (
  setData: Dispatch<SetStateAction<Message[]>>,
  setShouldScrollToBottom: Dispatch<SetStateAction<boolean>>,
) => {
  const [giveFeedback] = usePostApiParentHelperFeedbackByMessageIdMutation();

  const sendPostData = useCallback(
    (feedback: FeedbackType) =>
      giveFeedback(feedback)
        .unwrap()
        .then(() => {
          setData(prevData =>
            prevData.map((message: Message) =>
              message.id === feedback.messageId
                ? {
                    ...message,
                    isAnswerLiked:
                      feedback
                        .inspiredGlobalStudyPlatformApiModelsParentHelperAnswerFeedbackRequest
                        .liked,
                  }
                : message,
            ),
          );

          setShouldScrollToBottom(false);
        }),
    [giveFeedback, setData, setShouldScrollToBottom],
  );

  const likeMessage = useCallback(
    (messageId: FeedbackType['messageId']) =>
      sendPostData({
        messageId,
        inspiredGlobalStudyPlatformApiModelsParentHelperAnswerFeedbackRequest: {
          liked: true,
        },
      }),
    [sendPostData],
  );

  const dislikeMessage = useCallback(
    (feedback: FeedbackType) => sendPostData(feedback),
    [sendPostData],
  );

  return { likeMessage, dislikeMessage };
};
